import * as React from 'react';

interface IInitialAvatar {
  label: string;
  className?: string;
  colorClassName?: string;
}

export const InitialAvatar = ({
  label,
  className,
  colorClassName,
}: IInitialAvatar) => {
  const initial = label.trim().charAt(0).toUpperCase() || '?';

  return (
    <div
      className={`flex h-9 w-9 items-center justify-center rounded-full ${colorClassName ?? 'bg-sandwisp'} text-smallbody font-semibold text-black ${className ?? ''}`}
      aria-hidden="true">
      {initial}
    </div>
  );
};
